
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing, lifecycle } from 'recompose'
import Roles from './Roles'

const Component = compose(
  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.dispatch({
        type: 'SET_BREADCRUMB',
        items: [
          { page: 'Home', url: '/' },
          { page: 'Funções', url: '#' },
        ]
      })
    }
  }),
  branch(
    () => {
      return true
    },
    renderComponent(Roles),
    renderNothing
  )
)(Roles)

export default Component